import { Flex } from '@aws-amplify/ui-react';
import './ContactVerification.scss';

/**
 * 0-3 months ago: tier-1 (green)
 * 3-6 months ago: tier-2 (yellow)
 * 6-12 months ago: tier-3 (orange)
 * 12+ months ago: tier-4 (red)
 */
function getTierFromDate(date: string) {
  try {
    if (!date) return '';
    const diff = new Date().getTime() - new Date(date).getTime();
    const msPerMonth = 2592000000; // 30 days in milliseconds
    if (diff < msPerMonth * 3) return 'tier-1';  // 0-3 months
    if (diff < msPerMonth * 6) return 'tier-2';  // 3-6 months
    if (diff < msPerMonth * 12) return 'tier-3'; // 6-12 months
    return 'tier-4'; // 12+ months
  } catch (err) {
    return '';
  }
}

function getAgoTextFromTier(tier: string) {
  switch (tier) {
    case 'tier-1':
      return '0-3 months ago 🔥';
    case 'tier-2':
      return '3-6 months ago';
    case 'tier-3':
      return '6-12 months ago';
    case 'tier-4':
      return '12+ months ago';
    default:
      return '';
  }
}

export default function ContactVerification({ verification }: { verification: any }) {

  const districtTier = getTierFromDate(verification?.district?.date);
  const pageStaffTier = getTierFromDate(verification?.page_staff?.date);
  const pageOtherTier = getTierFromDate(verification?.page_other?.date);

  return <Flex className="contact-verification" gap='0px' direction='row'>
    <div
      className={`v ${verification?.district?.isVerified ? 'verified' : ''} ${districtTier}`}
      data-tooltip-hidden={!verification?.district?.isVerified}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={`Verified by the district ${getAgoTextFromTier(districtTier)}`}
      data-tooltip-delay-hide={0}
    >
      <div className="inner"></div>
    </div>
    <div
      className={`v ${verification?.page_staff?.isVerified ? 'verified' : ''} ${pageStaffTier}`}
      data-tooltip-hidden={!verification?.page_staff?.isVerified}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={`Found on staff directory ${getAgoTextFromTier(pageStaffTier)}`}
      data-tooltip-delay-hide={0}
    >
      <div className="inner"></div>
    </div>
    <div
      className={`v ${verification?.page_other?.isVerified ? 'verified' : ''} ${pageOtherTier}`}
      data-tooltip-hidden={!verification?.page_other?.isVerified}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={`Found outside the staff directory ${getAgoTextFromTier(pageOtherTier)}`}
      data-tooltip-delay-hide={0}
    >
      <div className="inner"></div>
    </div>
    <div
      className={`v ${verification?.email_domain?.isVerified ? 'verified' : ''} tier-1`}
      data-tooltip-hidden={!verification?.email_domain?.isVerified}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={`Email domain matches a K-12 institution 🧠`}
      data-tooltip-delay-hide={0}
    >
      <div className="inner"></div>
    </div>
    {/* <div
      className={`v ${verification?.web_search?.isVerified ? 'verified' : ''}`}
      data-tooltip-hidden={!verification?.web_search?.isVerified}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={`Found via web search`}
      data-tooltip-delay-hide={0}
    >
      <div className="inner"></div>
    </div> */}
  </Flex>
}
